import { AddVaccineForm } from "pages/patient/PatientImmunizationsPage/components/AddVaccineForm/AddVaccineForm.jsx";

import { useHealthlinkPracticeStatus } from "features/healthlink/hooks/useHealthlinkPracticeStatus";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

// Vaccines carry no consultationId — same as lab orders — so this is just the
// standalone form the Immunisations page uses, reached from the consult instead of
// a modal there.
export const VaccineTab = ({ onSuccess }) => {
  const patientId = useCurrentPatientId();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const { isConfigured: isHealthlinkConfigured } = useHealthlinkPracticeStatus();

  return (
    <AddVaccineForm
      currentPatientId={patientId}
      // AddVaccineForm calls this on both cancel and successful submit — there is
      // nothing to close here, so it just returns the GP to the note tab.
      closeModal={() => onSuccess?.()}
      tenantVal={tenantVal}
      healthlinkEnabled={isHealthlinkConfigured}
    />
  );
};
